import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControlLabel, Radio } from '@material-ui/core';

interface Props {
  id: string;
  name: string;
  value: string;
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  ariaLabel?: string;
}

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginBottom: '17px',
    marginRight: '0',
    marginLeft: '0'
  },
  label: {
    fontSize: 'var(--font-size-14)',
    marginLeft: '20px',
    '@media (min-width:769px)': {
      fontSize: 'var(--font-size-16)',
    },
  },
  radio: {
    transform: 'scale(1.6)',
    color: 'var(--black-03)',
    padding: '0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-checked': {
      color: 'var(--black-02)',
    },
  },
}));

const RadioButton: React.FC<Props> = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  className = '',
  ariaLabel,
}) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      className={`${classes.root} ${className}`}
      control={
        <Radio
          id={id}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          className={classes.radio}
          inputProps={{
            'aria-label': ariaLabel || label,
          }}
        />
      }
      label={label}
      classes={{ label: classes.label }}
    />
  );
};

export default RadioButton;
